import { api } from "./api";


export const companyRegisterApi = (params) => {
    return api.post(`/auth/company-register`, JSON.stringify(params));
};

